/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { CommonDataDtoGenericApiResponseFromJSON, TimeZoneInfoFromJSON, } from '../models';
/**
 *
 */
export class CommonDataApi extends runtime.BaseAPI {
    /**
     */
    apiCommonDataGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/CommonData`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CommonDataDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCommonDataGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCommonDataGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCommonDataGetAllTimeZonesGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/CommonData/GetAllTimeZones`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TimeZoneInfoFromJSON));
        });
    }
    /**
     */
    apiCommonDataGetAllTimeZonesGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCommonDataGetAllTimeZonesGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCommonDataGetTimeZoneByIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.id !== undefined) {
                queryParameters['id'] = requestParameters.id;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/CommonData/GetTimeZoneById`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => TimeZoneInfoFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCommonDataGetTimeZoneByIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCommonDataGetTimeZoneByIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
